/* Atelier - one light over the whole grid.

   A jeweller's tray is lit by a single lamp. Move your head and the light travels across all
   of the pieces at once - the ones nearest it flare, the ones at the edge stay dark. Nothing
   on an ecommerce grid does that, because each card is built as its own little world with its
   own hover state.

   This makes the pointer that lamp. Every card in range gets a highlight positioned from the
   pointer's real position relative to that card, at a strength that falls off with distance.
   Move across the grid and the light sweeps a dozen pieces rather than lighting one.

   It reuses the highlight element the tilt layer already injects, so it costs no new DOM and
   no new paint work - only custom property writes, which the compositor handles.

   Performance, because 36 cards is where this pattern usually falls over:

     - rectangles are measured once and re-measured on scroll and resize, never per frame
     - one document-level pointermove, rAF-throttled, never one listener per card
     - cards outside the viewport are skipped entirely
     - a value is only written when it has actually changed, so a still pointer writes nothing
     - the card under the pointer is left alone, because the tilt layer already owns it

   Off wherever the depth layer is off: no fine pointer, fewer than four cores, or
   reduced-motion. */
(function () {
  'use strict';

  var RADIUS = 620;   // px from the pointer at which a card gets no light at all
  var MAX = 0.5;      // ceiling for --t3-glow, matching the tilt layer's own maximum

  var cards = [];
  var grid = null;
  var px = 0, py = 0;
  var frame = null;
  var measureFrame = null;

  function armed() {
    return document.documentElement.classList.contains('t3-on');
  }

  function measure() {
    measureFrame = null;
    var sy = window.scrollY;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var b = c.host.getBoundingClientRect();
      if (!b.width) { c.w = 0; continue; }
      c.left = b.left;
      c.top = b.top + sy;
      c.w = b.width;
      c.h = b.height;
      c.cx = c.left + c.w / 2;
      c.cy = c.top + c.h / 2;
    }
  }

  function scheduleMeasure() {
    if (measureFrame) return;
    measureFrame = window.requestAnimationFrame(measure);
  }

  function collect() {
    grid = document.getElementById('product-grid');
    if (!grid) return;

    cards = [].slice.call(grid.querySelectorAll('.card-wrapper')).map(function (el) {
      /* The highlight lives on the media box, so the light is positioned against the
         photograph rather than against the whole card including its text. */
      var host = el.querySelector('.card__inner') || el;
      return { el: el, host: host, w: 0, glow: -1 };
    });

    measure();
  }

  function setGlow(c, v) {
    if (Math.abs(c.glow - v) < 0.012) return;
    c.glow = v;
    c.el.style.setProperty('--t3-glow', v.toFixed(3));
  }

  function paint() {
    frame = null;

    var sy = window.scrollY;
    var vh = window.innerHeight;

    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (!c.w) continue;

      var y = c.top - sy;
      if (y > vh + 200 || y + c.h < -200) { setGlow(c, 0); continue; }

      /* The pointer is over this card: the tilt layer is already writing its highlight from
         the same properties, and two writers produce a flicker. */
      if (c.el.classList.contains('is-live')) continue;

      var dx = px - c.cx;
      var dy = py - c.cy;
      var d = Math.sqrt(dx * dx + dy * dy);

      if (d > RADIUS) { setGlow(c, 0); continue; }

      var f = 1 - d / RADIUS;
      f = f * f;                       // squared, so the falloff reads like real light

      var mx = ((px - c.left) / c.w) * 100;
      var my = ((py - c.top) / c.h) * 100;

      /* Clamped rather than dropped: a light just off the edge of a card should still catch
         that edge, which is the whole point of a shared source. */
      if (mx < -40) mx = -40; else if (mx > 140) mx = 140;
      if (my < -40) my = -40; else if (my > 140) my = 140;

      c.el.style.setProperty('--t3-mx', mx.toFixed(1) + '%');
      c.el.style.setProperty('--t3-my', my.toFixed(1) + '%');
      setGlow(c, MAX * f);
    }
  }

  function move(e) {
    px = e.clientX;
    py = e.clientY + window.scrollY;
    if (!frame) frame = window.requestAnimationFrame(paint);
  }

  function douse() {
    for (var i = 0; i < cards.length; i++) setGlow(cards[i], 0);
  }

  function init() {
    if (!armed()) return;

    collect();
    if (!cards.length) return;

    document.addEventListener('pointermove', move, { passive: true });
    document.addEventListener('pointerleave', douse);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) douse();
    });

    window.addEventListener('scroll', function () {
      scheduleMeasure();
      if (!frame) frame = window.requestAnimationFrame(paint);
    }, { passive: true });

    window.addEventListener('resize', scheduleMeasure);

    /* Dawn swaps the whole grid out when a filter or sort changes. */
    var host = document.getElementById('ProductGridContainer') || document.querySelector('main');
    if (host) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = window.setTimeout(function () { pending = null; collect(); }, 250);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  /* The tilt layer sets .t3-on during its own init, and both scripts are deferred, so give
     the class a moment to land rather than racing it. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(init, 60); });
  } else {
    window.setTimeout(init, 60);
  }
})();